module.exports = __webpack_public_path__ + "static/img/b_2.8217432.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b_2.jpg
// module id = 251
// module chunks = 0 1 2 3 4 5 6 7 8 9